var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgDropSilhouette = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.059091 0 0 .059091 .65297 .85311)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m273.22 106.9c-27.181-44.864-57.413-83.693-73.016-102.85-2.088-2.565-5.221-4.054-8.528-4.053-3.308 0-6.44 1.489-8.529 4.054-15.602 19.159-45.834 58.001-73.015 102.87-35.028 57.823-52.789 105.63-52.789 142.09 0 74.071 60.261 134.33 134.33 134.33s134.33-60.261 134.33-134.33c1e-3 -36.484-17.758-84.298-52.787-142.11zm-63.111 226.97c-7.844 2.006-15.986 3.022-24.205 3.022-50.186 0-91.015-37.929-91.015-84.55 0-11.255 2.97-24.405 8.825-39.083 0.989-2.48 3.807-3.895 6.585-3.295 2.776 0.598 4.64 3.018 4.354 5.65-0.342 3.148-0.516 6.223-0.516 9.136 0 50.735 40.881 93.221 95.093 98.821 2.698 0.279 4.803 2.297 5.018 4.812 0.216 2.515-1.522 4.817-4.139 5.487z"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDropSilhouette, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/drop-silhouette.d55d24fb.svg";
export { ForwardRef as ReactComponent };